import React from "react";
import SEO from "../components/SEO";
import CardsSection from "../components/CardsSection";
import Hero from "../components/Hero";
import { Link } from "react-router-dom";  
import { FaWhatsapp } from 'react-icons/fa';

const Home = () => {
  const membershipCategories = [
    {
      id: 1,
      title: "PRESS MEDIA",
      icon: "📰",
      description:
        "Print media are lightweight, portable, disposable publications printed on paper and circulated as physical copies in forms we call books, newspapers, magazines and newsletters.",
      details: [
        "Books, Newspapers, Magazines and Newsletters",
        "Informative and entertaining content",
        "General or special interest publications",
        "Published daily, weekly, monthly or quarterly",
      ],
      buttonText: "Apply for Print Media",
      link: "/apply/press-media",
      color: "from-blue-600 to-blue-700",
      bgColor: "blue",
    },
    {
      id: 2,
      title: "BROADCASTING MEDIA (TV & RADIO)",
      icon: "📺",
      description:
        "Broadcast and electronic media today are portable sources of entertainment and information distributed by wired and wireless radio and television stations and networks.",
      details: [
        "Television and Radio Stations",
        "Sound and video recordings",
        "Wired and wireless distribution",
        "Mobile Internet broadcasting",
      ],
      buttonText: "Apply for Broadcasting",
      link: "/apply/broadcasting",
      color: "from-purple-600 to-purple-700",
      bgColor: "purple",
    },
    {
      id: 3,
      title: "DIGITAL MEDIA",
      icon: "💻",
      description:
        "Digital media are Internet sites where people interact freely, sharing and discussing information about each other and their lives, using a multimedia mix of personal words, pictures, videos and audio.",
      details: [
        "Web TV and Online e-News",
        "Multimedia content sharing",
        "Interactive Internet platforms",
        "Social media and digital publications",
      ],
      buttonText: "Apply for Digital Media",
      link: "/apply/digital-media",
      color: "from-green-600 to-green-700",
      bgColor: "green",
    },
    {
      id: 4,
      title: "CITIZEN REPORTER",
      icon: "🎤",
      description:
        "Citizen reporter is derived from Citizen Journalism. Citizen reporter take up an initiative to express ideas irrespective of their educational or professional background.",
      details: [
        "No educational or professional barriers",
        "Breaking free from media bias",
        "Local news on global platform",
        "Community-driven journalism",
      ],
      buttonText: "Apply as Citizen Reporter",
      link: "/apply/citizen-reporter",
      color: "from-orange-600 to-orange-700",
      bgColor: "orange",
    },
  ];

  const getIconColor = (bgColor) => {
    const colors = {
      blue: "bg-blue-100 text-blue-600",
      purple: "bg-purple-100 text-purple-600",
      green: "bg-green-100 text-green-600",
      orange: "bg-orange-100 text-orange-600",
    };
    return colors[bgColor] || "bg-gray-100 text-gray-600";
  };

  const getDetailIconColor = (bgColor) => {
    const colors = {
      blue: "text-blue-500",
      purple: "text-purple-500",
      green: "text-green-500",
      orange: "text-orange-500",
    };
    return colors[bgColor] || "text-gray-500";
  };
  return (
    <div className="min-h-screen bg-white">
      <SEO 
        title="Newsmedia Association of India - Official Website"
        description="Newsmedia Association of India (NAI) is India's leading source for multi-media journalists & professionals protection. Defending press freedom and quality journalism."
        keywords="NAI, Newsmedia Association of India, Journalist Protection, Media Rights, Press Freedom, Digital Media, Citizen Journalism"
      />
      <Hero />
      <CardsSection />

      {/* WhatsApp Channels Section */}
      <section className="py-12 bg-gradient-to-b from-gray-50 to-white border-b border-gray-150">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-extrabold text-gray-900 flex items-center justify-center gap-3">
              <span className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center text-green-500 shadow-sm animate-pulse">
                <FaWhatsapp className="w-6 h-6" />
              </span>
              Join our Police News Plus WhatsApp Channels
            </h2>
            <p className="text-gray-600 mt-2 text-base md:text-lg">
              Join our WhatsApp Channels and get daily news updates.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              {
                lang: "English Updates",
                url: "https://whatsapp.com/channel/0029Vb7lnet90x2os76qzH3R",
                desc: "Join our English channel to get daily news updates.",
              },
              {
                lang: "Tamil Updates",
                url: "https://whatsapp.com/channel/0029VaD3uYr72WTrmyxWKi1v",
                desc: "Join our Tamil channel to get daily news updates.",
              },
              {
                lang: "Kannada Updates",
                url: "https://whatsapp.com/channel/0029VayAxMf2Jl8GKZhsya2z",
                desc: "Join our Kannada channel to get daily news updates.",
              },
              {
                lang: "Telugu Updates",
                url: "https://whatsapp.com/channel/0029Vb8zNaoBKfhwld77HK45",
                desc: "Join our Telugu channel to get daily news updates.",
              }
            ].map((channel, idx) => (
              <div 
                key={idx} 
                className="bg-white p-6 rounded-2xl border border-gray-100 shadow-sm hover:shadow-xl hover:border-green-200 transition-all duration-300 flex flex-col justify-between transform hover:-translate-y-1 group"
              >
                <div>
                  <div className="flex items-center justify-between mb-4">
                    <span className="text-xl font-bold text-gray-900 group-hover:text-green-600 transition-colors">
                      {channel.lang}
                    </span>
                    <span className="w-8 h-8 rounded-full bg-green-50 text-green-500 flex items-center justify-center">
                      <FaWhatsapp className="w-5 h-5" />
                    </span>
                  </div>
                  <p className="text-sm text-gray-600 leading-relaxed mb-6">
                    {channel.desc}
                  </p>
                </div>
                <a
                  href={channel.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-4 rounded-xl text-center shadow-md hover:shadow-lg transition-all duration-200 flex items-center justify-center gap-2 text-sm"
                >
                  <FaWhatsapp size={18} />
                  Join Channel
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Mission & Challenges Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-8">
                Our Mission & Challenges
              </h2>
              <div className="space-y-6 text-gray-700 text-lg leading-relaxed">
                <p>
                  The Multi-Media Industry members at national level face
                  physical violence and persecution of all kinds, whether from
                  public officials, criminals or terrorists. Assaults are daily
                  – and often deadly – for those who challenge governments,
                  report on conflicts or investigate corruption and crime.
                </p>
                <p>
                  <strong>Newsmedia Association of India (NAI)</strong> core
                  mission is to defend and promote press/media freedom, quality
                  journalism and editorial integrity and the development.
                </p>
              </div>
            </div>
            <div className="flex justify-center">
              <div className="w-full h-80 bg-gray-200 rounded-2xl flex items-center justify-center">
                <img src="../images/citizen_reporter.jpg" alt="Mission & Challenges" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Partnership & Approach Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1">
              <div className="w-full h-80 bg-gray-300 rounded-2xl flex items-center justify-center">
                 <img src="../images/nai.webp" alt="Mission & Challenges" />
              </div>
            </div>
            <div className="order-1 lg:order-2">
              <h2 className="text-4xl font-bold text-gray-900 mb-8">
                Our Partnership Approach
              </h2>
              <div className="space-y-6 text-gray-700 text-lg leading-relaxed">
                <p>
                  NAI works in close partnership with local media and media
                  support organisations, our proposed plan is that nationally as
                  well as internationally to identify and react rapidly and
                  flexibly to the needs of local media.
                </p>
                <p>
                  We seek to address all aspects of the media sector from media
                  laws to skills training and the protection of journalists.
                </p>
                <p>
                  NAI undertakes its work in a cooperative and collaborative
                  manner, seeking to encourage maximum coordination with
                  existing local and international initiatives. NAI seeks to act
                  flexibly and, when necessary, rapidly.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What We Do Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              What We Do
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              NAI works to promote freedom of expression and helps multi-media
              members fulfill their tasks through various initiatives
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                title: "Safety & Protection",
                description:
                  "Providing safety and protection for Journalists / Media members",
              },
              {
                title: "Media Rights Advocacy",
                description:
                  "Advocating media rights and monitoring violations",
              },
              {
                title: "Legal Reforms",
                description: "Promoting fair media laws and media reforms",
              },
              {
                title: "Media Support",
                description:
                  "Supporting community, exiled and alternative media",
              },
              {
                title: "Technical Support",
                description: "Providing technical support and building skills",
              },
              {
                title: "Specialized Training",
                description:
                  "Organising specialised training for media workers",
              },
              {
                title: "Content Monitoring",
                description:
                  "Monitoring media content to promote fair and balanced media coverage",
              },
              {
                title: "Global Partnerships",
                description:
                  "Partnering likeminded media professionals within and across borders",
              },
              {
                title: "Democracy Protection",
                description:
                  "To protect and strengthen the press as a pillar of democracy",
              },
            ].map((item, index) => (
              <div
                key={index}
                className="bg-white p-6 rounded-xl shadow-lg border border-gray-100 hover:shadow-xl transition-shadow duration-300"
              >
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                  <svg
                    className="w-6 h-6 text-blue-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {item.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Objectives Section */}
      {/* <section className="py-20 bg-[#2ec0f9] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4">Our Core Objectives</h2>
            <p className="text-xl text-blue-100 max-w-2xl mx-auto">
              Driving excellence and responsibility in Indian journalism
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {[
              "To establish a framework of responsibility and ethics in the practice of the press",
              "To raise levels of competence for coverage of special areas of news",
              "To promote journalistic excellence",
              "To engage different sectors of society in the growth of a quality press in India",
            ].map((objective, index) => (
              <div
                key={index}
                className="bg-[#f8f9fb] p-6 rounded-xl hover:bg-[#e1ecf7] transition-colors duration-300"
              >
                <div className="flex items-start">
                  <div className="flex-shrink-0 w-8 h-8 bg-white bg-opacity-20 rounded-full flex items-center justify-center mr-4 mt-1">
                    <span className="text-[#212121] font-bold">
                      {index + 1}
                    </span>
                  </div>
                  <p className="text-lg text-[#001100] leading-relaxed">
                    {objective}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Call to Action: Become a Citizen Reporter */}
      <section className="py-20 bg-gradient-to-br from-slate-900 via-indigo-950 to-slate-900 text-white relative overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_30%,rgba(59,130,246,0.1),transparent_50%)]"></div>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_70%,rgba(236,72,153,0.05),transparent_50%)]"></div>
        
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
          <span className="text-blue-400 font-bold uppercase tracking-widest text-sm block mb-3">
            Call to Action
          </span>
          <h2 className="text-4xl md:text-5xl font-black mb-6 tracking-tight leading-tight">
            Become a <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-teal-300">Citizen Reporter</span> in Police News Plus!
          </h2>
          <p className="text-xl md:text-2xl font-medium text-slate-200 mb-8 max-w-3xl mx-auto italic">
            "Do you have a passion for serving society and reporting truthful information?"
          </p>
          <div className="max-w-3xl mx-auto bg-white/5 border border-white/10 backdrop-blur-md p-8 rounded-2xl mb-10">
            <p className="text-lg md:text-xl text-slate-300 leading-relaxed">
              The Newsmedia Association of India invites responsible citizens to become Citizen Reporters. Together, let's build a stronger, more informed community by reporting news that matters.
            </p>
          </div>
          <div>
            <Link
              to="/apply/citizen-reporter"
              className="inline-flex items-center justify-center bg-gradient-to-r from-blue-500 to-teal-400 hover:from-blue-600 hover:to-teal-500 text-white font-bold text-lg py-4 px-8 rounded-xl transition-all duration-300 transform hover:scale-105 shadow-[0_0_20px_rgba(59,130,246,0.4)] group"
            >
              Apply Online Today
              <svg
                className="w-5 h-5 ml-3 transform group-hover:translate-x-1 transition-transform duration-300"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2.5}
                  d="M13 7l5 5m0 0l-5 5m5-5H6"
                />
              </svg>
            </Link>
          </div>
        </div>
      </section>

      {/* Catalyst Function Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl font-bold text-gray-900 mb-8 text-center">
              Citizen Reporting
            </h2>
            
            <div className="prose prose-lg mx-auto text-gray-700">
              <p className="mb-8 text-justify leading-relaxed">
                Citizen journalism has become increasingly popular across the globe. Reports from these non-traditional journalists frequently appear in print media, television broadcasts, and online news platforms. As its popularity rises, more people are drawn toward participating in this emerging field. Therefore, understanding its major benefits becomes essential. This new movement in the journalism industry empowers ordinary citizens to collect, analyze, share, and report news. They actively participate in journalism outside traditional media institutions and often bridge gaps created by limitations within mainstream media. Citizen journalism is also known by various other names, including democratic journalism, guerrilla journalism, public journalism, and participatory journalism.
              </p>

              <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
                Top 3 Benefits of Citizen Reporting
              </h3>

              <div className="space-y-6 mb-10">
                <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
                  <h4 className="text-xl font-bold text-blue-600 mb-3">1. Easy Access to Ongoing Events</h4>
                  <p className="text-gray-700 leading-relaxed">
                    In today’s technology-driven world, most people are familiar with digital tools. The rise of online platforms such as Twitter, YouTube, and Facebook has made the spread of information quicker and simpler. Additionally, smartphones equipped with cameras and internet connectivity allow individuals to capture real-time events effortlessly. These advancements have paved the way for citizen journalism. Regardless of formal training or approval from media organizations, anyone can participate in sharing news and information.
                  </p>
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
                  <h4 className="text-xl font-bold text-blue-600 mb-3">2. Offers a Fresh Perspective</h4>
                  <p className="text-gray-700 leading-relaxed">
                    Because ordinary citizens are involved in reporting, the information shared often reflects the viewpoint of locals and those directly affected by events. This introduces diverse perspectives to both the public and authorities. It encourages community engagement and can help bring positive changes to society and governance.
                  </p>
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
                  <h4 className="text-xl font-bold text-blue-600 mb-3">3. Supports Professional Journalists</h4>
                  <p className="text-gray-700 leading-relaxed">
                    Many newspapers and television networks appreciate and encourage citizen journalism. Some active citizen journalists receive opportunities to appear in major news stories or collaborate with trained professional journalists who possess academic qualifications and industry experience.
                  </p>
                </div>
              </div>

              <p className="text-justify leading-relaxed">
                Citizen journalism has grown beyond a simple field—it has become a passion for many. People worldwide frequently come across videos, images, and written updates reported by citizen journalists. This new dimension has made journalism more dynamic and accessible, even for individuals who could not pursue it professionally. Online participatory journalism also opens doors for citizens to earn income. Ultimately, it is an appealing, expanding, and influential arena in today’s media landscape.
              </p>
            </div>
          </div>
        </div>
      </section>

        {/* Membership Categories */}
            <section className="py-20">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                  <h2 className="text-4xl font-bold text-gray-900 mb-4">
                    Choose Your Membership Category
                  </h2>
                  <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                    Select the category that best describes your media platform and
                    join our growing community of media professionals
                  </p>
                  <div className="w-24 h-1 bg-blue-600 mx-auto mt-6 rounded-full"></div>
                </div>
      
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                  {membershipCategories.map((category) => (
                    <div
                      key={category.id}
                      className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden border border-gray-100 group"
                    >
                      {/* Header with Gradient */}
                      <div className={`bg-gradient-to-r ${category.color} p-6`}>
                        <div className="flex items-center justify-between">
                          <div className="flex items-center space-x-4">
                            <div
                              className={`w-16 h-16 rounded-2xl ${getIconColor(
                                category.bgColor
                              )} flex items-center justify-center text-2xl`}
                            >
                              {category.icon}
                            </div>
                            <h3 className="text-2xl font-bold text-white">
                              {category.title}
                            </h3>
                          </div>
                        </div>
                      </div>
      
                      {/* Content */}
                      <div className="p-6">
                        {/* Description */}
                        <p className="text-gray-700 text-lg leading-relaxed mb-6">
                          {category.description}
                        </p>
      
                        {/* Features List */}
                        <div className="mb-6">
                          <h4 className="font-semibold text-gray-900 mb-4 text-lg">
                            Includes:
                          </h4>
                          <ul className="space-y-3">
                            {category.details.map((detail, index) => (
                              <li key={index} className="flex items-start">
                                <svg
                                  className={`w-5 h-5 mr-3 mt-0.5 flex-shrink-0 ${getDetailIconColor(
                                    category.bgColor
                                  )}`}
                                  fill="currentColor"
                                  viewBox="0 0 20 20"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                                <span className="text-gray-600">{detail}</span>
                              </li>
                            ))}
                          </ul>
                        </div>
      
                        {/* Action Button */}
                        <Link
                          to={category.link}
                          className={`group/btn w-full bg-gradient-to-r ${category.color} hover:opacity-90 text-white font-bold py-4 px-6 rounded-xl transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl flex items-center justify-center`}
                        >
                          <span className="text-lg">{category.buttonText}</span>
                          <svg
                            className="w-5 h-5 ml-3 transform group-hover/btn:translate-x-1 transition-transform duration-300"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M13 7l5 5m0 0l-5 5m5-5H6"
                            />
                          </svg>
                        </Link>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </section>

      {/* What Does a Citizen Reporter Do Section */}
      <section className="py-20 bg-gradient-to-b from-slate-50 to-white border-t border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <span className="text-blue-600 font-bold tracking-wider text-sm uppercase block mb-3">
              Police News Plus
            </span>
            <h2 className="text-4xl font-extrabold text-gray-900 mb-6 md:text-5xl">
              What Does a Citizen Reporter Do?
            </h2>
            <div className="w-24 h-1 bg-blue-600 mx-auto rounded-full mb-6"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed font-medium">
              Anyone appointed as a citizen reporter for Police News Plus will also be considered a member of the association.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                title: "Share Good Deeds & Sacrifices",
                desc: "You can compile and share the good deeds and achievements of police officers you observe daily in your area — stories of police sacrifices, officers' experiences, poems about them, and details about officers who have received awards.",
                icon: "🏆",
                color: "from-amber-500/10 to-orange-500/10 text-orange-600",
              },
              {
                title: "Build Friendly Bridges",
                desc: "A Police News Plus citizen reporter must never forget, under any circumstances, that police department officers are our friends.",
                icon: "🤝",
                color: "from-blue-500/10 to-indigo-500/10 text-blue-600",
              },
              {
                title: "Conduct Senior Interviews",
                desc: "You may conduct special interviews with senior police officials in your area — Inspectors, Deputy Inspectors, and other officers — about their experiences. Proper training for this (Citizen Reporter Workshop) will be provided to you.",
                icon: "🎤",
                color: "from-purple-500/10 to-pink-500/10 text-purple-600",
              },
              {
                title: "Encourage On-Duty Officers",
                desc: "A Police News Plus citizen reporter should encourage police officers. For example, you can show our affection by offering a cool drink or buttermilk to traffic police officers working in the hot sun.",
                icon: "🥤",
                color: "from-teal-500/10 to-emerald-500/10 text-teal-600",
              },
              {
                title: "Behave Respectfully",
                desc: "A Police News Plus citizen reporter must behave respectfully with police officers. They should not be opposed or confronted.",
                icon: "👮",
                color: "from-sky-500/10 to-blue-500/10 text-sky-600",
              },
              {
                title: "Cover Local Community News",
                desc: "A Police News Plus citizen reporter can also send other news happening in your town to the leadership, not just police-related news.",
                icon: "🌍",
                color: "from-red-500/10 to-rose-500/10 text-red-600",
              },
            ].map((item, index) => (
              <div
                key={index}
                className="bg-white p-8 rounded-2xl border border-gray-100 hover:border-gray-200 shadow-sm hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
              >
                <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${item.color} flex items-center justify-center text-3xl mb-6 shadow-sm`}>
                  {item.icon}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {item.title}
                </h3>
                <p className="text-gray-600 leading-relaxed text-base">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Police News Plus Section */}
      <section className="py-20 bg-white border-t border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          {/* Header */}
          <div className="text-center mb-16">
            <span className="text-blue-600 font-bold tracking-wider text-sm uppercase block mb-3">
              Official Media Wing
            </span>
            <h2 className="text-4xl font-extrabold text-gray-900 mb-6 md:text-5xl">
              About Police News Plus
            </h2>
            <div className="w-24 h-1 bg-blue-600 mx-auto rounded-full"></div>
          </div>

          {/* Narrative Content Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start mb-16">
            <div className="lg:col-span-7 space-y-6">
              <p className="text-lg text-gray-700 leading-relaxed font-medium">
                For the first time in India, we have launched a dedicated digital e-News platform exclusively for the police. The inaugural edition of <span className="font-semibold text-blue-600">Police News Plus</span> was published online on <span className="font-semibold text-gray-900">December 11, 2013 (11.12.2013)</span>, specifically designed for police officers (IPS & Non-IPS) whose focus is on maintaining law and order, as well as various other allied police departments.
              </p>
              <p className="text-base text-gray-600 leading-relaxed">
                The core mission of Police News Plus is to build a constructive bridge between the police force and the general public, fostering mutual trust and maintaining strong, positive relationships. We highlight the outstanding achievements, exclusive interviews, and public service contributions of district police heads (IPS Officers) and district collectors (IAS Officers) dedicated to social betterment and administration.
              </p>
              <p className="text-base text-gray-600 leading-relaxed">
                Our portal, <a href="https://www.policenewsplus.com" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 underline font-semibold">www.policenewsplus.com</a>, provides an online platform for readers nationwide to understand the police force's dedication and services. The launch date of <span className="font-semibold text-gray-900">11.12.2013</span> represents a rare and historic numeric sequence of this century—a special date alignment that occurs only once every 100 years.
              </p>
            </div>

            {/* Quick Stats / Highlights Box */}
            <div className="lg:col-span-5 bg-gradient-to-br from-blue-50 to-indigo-50 p-8 rounded-3xl border border-blue-100/50 shadow-sm space-y-6">
              <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                <span className="text-2xl">✨</span> Platform Highlights
              </h3>
              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-xl bg-blue-150 flex items-center justify-center text-blue-600 shrink-0 font-bold">1st</div>
                  <div>
                    <h4 className="font-bold text-gray-900">India's First for Police</h4>
                    <p className="text-sm text-gray-600">Dedicated digital e-News platform focused exclusively on police & administration affairs.</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-xl bg-blue-150 flex items-center justify-center text-blue-600 shrink-0">🤝</div>
                  <div>
                    <h4 className="font-bold text-gray-900">Bridge to the Public</h4>
                    <p className="text-sm text-gray-600">Fostering healthy interactions, understanding, and positive relations with citizens.</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-xl bg-blue-150 flex items-center justify-center text-blue-600 shrink-0">📅</div>
                  <div>
                    <h4 className="font-bold text-gray-900">Historic Launch Date</h4>
                    <p className="text-sm text-gray-600">Launched on the once-in-a-century special date of 11.12.2013.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Inaugurators Sub-Section */}
          <div className="border-t border-gray-150 pt-16">
            <h3 className="text-2xl font-bold text-gray-900 text-center mb-12">
              Inaugurated By Respected Dignitaries
            </h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
              
              {/* Dignitary 1: Pradeep Philip */}
              <div className="bg-gray-50 rounded-3xl p-6 border border-gray-100 flex flex-col md:flex-row gap-6 items-center shadow-sm hover:shadow-md transition-shadow">
                <img 
                  src="/images/Pradeep Philip.jpeg" 
                  alt="Mr. Pradeep A. Philip IPS" 
                  className="w-32 h-32 md:w-36 md:h-36 rounded-2xl object-cover shadow-sm bg-gray-200 border border-gray-100 shrink-0"
                />
                <div className="text-center md:text-left">
                  <span className="inline-block px-3 py-1 bg-blue-100 text-blue-700 text-xs font-bold rounded-full mb-3 uppercase tracking-wider">
                    English Site
                  </span>
                  <h4 className="text-lg font-bold text-gray-900 mb-2">
                    Mr. Pradeep A. Philip IPS
                  </h4>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    Director General of Police, Tamil Nadu Police (Retired) and Founder of Friends of Police.
                  </p>
                </div>
              </div>

              {/* Dignitary 2: R. Dhinakaran */}
              <div className="bg-gray-50 rounded-3xl p-6 border border-gray-100 flex flex-col md:flex-row gap-6 items-center shadow-sm hover:shadow-md transition-shadow">
                <img 
                  src="/images/Dinakaran.png" 
                  alt="Dr. R. Dhinakaran IPS" 
                  className="w-32 h-32 md:w-36 md:h-36 rounded-2xl object-cover shadow-sm bg-gray-200 border border-gray-100 shrink-0"
                />
                <div className="text-center md:text-left">
                  <span className="inline-block px-3 py-1 bg-blue-100 text-blue-700 text-xs font-bold rounded-full mb-3 uppercase tracking-wider">
                    Tamil Site
                  </span>
                  <h4 className="text-lg font-bold text-gray-900 mb-2">
                    Dr. R. Dhinakaran IPS
                  </h4>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    Additional Director General of Police - Armed Police, Tamil Nadu.
                  </p>
                </div>
              </div>

            </div>
          </div>

        </div>
      </section>

      {/* Police Day Section */}
      <section className="py-20 bg-gray-50 border-t border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <span className="text-blue-600 font-bold tracking-wider text-sm uppercase block mb-3">
              Promoted by the Newsmedia Association of India
            </span>
            <h2 className="text-4xl font-extrabold text-gray-900 mb-6 md:text-5xl">
              Police Day — December 24
            </h2>
            <div className="w-24 h-1 bg-blue-600 mx-auto rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            {/* Image Side */}
            <div className="lg:col-span-5 flex justify-center">
              <div className="w-full max-w-lg rounded-2xl overflow-hidden shadow-2xl border-4 border-white transform hover:scale-[1.02] transition-transform duration-300">
                <img 
                  src="/images/24-12-20XX.png" 
                  alt="Police Day - Celebrating Indian Police Force" 
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>

            {/* Content Side */}
            <div className="lg:col-span-7 space-y-8">
              <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
                <h3 className="text-xl font-bold text-blue-600 mb-2 flex items-center">
                  <span className="text-2xl mr-3">❓</span> What is Police Day?
                </h3>
                <p className="text-gray-700 leading-relaxed text-base">
                  Police Day is a public initiative that calls upon citizens across India to honour and celebrate the police force at their local police stations. Unlike a solemn remembrance day, it is a day when bouquets, sweets, and mementos are given to policemen on behalf of the public to encourage and honor them for their sacrifices, service, and sense of duty. It is meant to be a joyous occasion of gratitude, not mourning. <span className="font-semibold text-blue-600">#Nationalpoliceday</span>
                </p>
              </div>

              <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
                <h3 className="text-xl font-bold text-blue-600 mb-2 flex items-center">
                  <span className="text-2xl mr-3">🌟</span> Why Police Day?
                </h3>
                <p className="text-gray-700 leading-relaxed text-base">
                  Police officers work around the clock, all twelve months of the year, providing security for the public. They do not take leave on festivals or holidays — while families sleep safely at night or celebrate together, police personnel remain on duty, often away from their own loved ones. Police Day exists to remind the public of these everyday sacrifices and to turn appreciation into action, encouraging residents in each police station's jurisdiction to come together in gratitude. <span className="font-semibold text-blue-600">#Nationalpoliceday</span>
                </p>
              </div>

              <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
                <h3 className="text-xl font-bold text-blue-600 mb-2 flex items-center">
                  <span className="text-2xl mr-3">📅</span> When is Police Day?
                </h3>
                <p className="text-gray-700 leading-relaxed text-base">
                  Police Day is observed every year on <strong>24th December</strong> — chosen because the number 24 (hours) and 12 (months) represent the round-the-clock, year-round service of the police.
                </p>
              </div>

              <div className="pt-4 flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-gray-200">
                <div>
                  <span className="text-sm font-semibold text-gray-500 uppercase tracking-wider block">For More Info</span>
                  <a 
                    href="https://www.nationalpoliceday.in" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="text-lg font-bold text-blue-600 hover:text-blue-700 flex items-center gap-1 group"
                  >
                    www.nationalpoliceday.in
                    <svg className="w-4 h-4 transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="py-20 bg-[#f26ca7] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">
            Join the Movement for Press Freedom
          </h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto text-red-100">
            Stand with us in defending media rights, protecting journalists, and
            promoting quality journalism across India.
          </p>
          <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-6">
            <Link to="/apply" className="bg-white text-red-600 hover:bg-gray-100 px-8 py-4 rounded-lg font-semibold text-lg transition-colors duration-300">
              Become a Member
            </Link>
            <button className="border-2 border-white hover:bg-white hover:text-red-600 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-colors duration-300">
              Support Our Work
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
